import { render, staticRenderFns } from "./diagnostic-percentage-score.vue?vue&type=template&id=3087b211&"
import script from "./diagnostic-percentage-score.ts?vue&type=script&lang=ts&"
export * from "./diagnostic-percentage-score.ts?vue&type=script&lang=ts&"
import style0 from "./diagnostic-percentage-score.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports